(() => {
  const initialisedProducts = new WeakSet();
  const pendingLabel = 'Selecciona tu talla';
  let hintIndex = 0;

  const updateCartCount = (itemCount) => {
    const cartLink = document.querySelector('.bordi-site-header__cart');
    if (!cartLink) return;

    const parsedCount = Number(itemCount);
    if (!Number.isFinite(parsedCount)) return;

    const count = Math.max(parsedCount, 0);
    let bubble = cartLink.querySelector('[data-bordi-cart-count]');

    if (count === 0) {
      bubble?.remove();
      cartLink.setAttribute('aria-label', 'Carrito');
      return;
    }

    if (!bubble) {
      bubble = document.createElement('span');
      bubble.dataset.bordiCartCount = '';
      bubble.setAttribute('aria-hidden', 'true');
      cartLink.appendChild(bubble);
    }

    bubble.textContent = count > 99 ? '99+' : String(count);
    cartLink.setAttribute('aria-label', `Carrito, ${count} ${count === 1 ? 'producto' : 'productos'}`);
  };

  window.BordiCartUI = Object.assign(window.BordiCartUI || {}, { updateCount: updateCartCount });

  const getSizeInputs = (productInfo) =>
    Array.from(productInfo.querySelectorAll('label.bordi-size-option'))
      .map((label) => label.control || document.getElementById(label.htmlFor))
      .filter((input) => input?.matches('input[type="radio"]'));

  const getAvailableSizeInputs = (productInfo) =>
    getSizeInputs(productInfo).filter((input) => !input.disabled && !input.classList.contains('disabled'));

  const getProductForm = (productInfo) => productInfo.querySelector('product-form');

  const setPendingButton = (productInfo) => {
    const productForm = getProductForm(productInfo);
    const button = productForm?.querySelector('[type="submit"][name="add"]');
    if (!button) return;

    if (typeof productForm.toggleSubmitButton === 'function') {
      productForm.toggleSubmitButton(true, pendingLabel);
    } else {
      button.disabled = true;
      const label = button.querySelector(':scope > span');
      if (label) label.textContent = pendingLabel;
    }
  };

  const addSelectionHint = (productInfo, sizeInputs) => {
    const fieldset = sizeInputs[0]?.closest('fieldset');
    const legend = fieldset?.querySelector('legend');
    if (!fieldset || !legend || fieldset.querySelector('[data-bordi-size-selection-hint]')) return;

    const hint = document.createElement('span');
    hintIndex += 1;
    hint.id = `${productInfo.id || `bordi-product-${hintIndex}`}-size-selection-hint`;
    hint.className = 'bordi-size-selection-hint';
    hint.dataset.bordiSizeSelectionHint = '';
    hint.setAttribute('role', 'status');
    hint.setAttribute('aria-live', 'polite');
    hint.textContent = 'Elige una opción para continuar';
    legend.appendChild(hint);
    fieldset.setAttribute('aria-describedby', hint.id);
  };

  const initialiseExplicitSize = (productInfo) => {
    if (!productInfo || initialisedProducts.has(productInfo)) return;

    const sizeInputs = getSizeInputs(productInfo);
    if (!sizeInputs.length || !getAvailableSizeInputs(productInfo).length) return;

    initialisedProducts.add(productInfo);
    productInfo.dataset.bordiRequiresSize = 'true';
    productInfo.dataset.bordiSizeSelected = 'false';

    sizeInputs.forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });

    addSelectionHint(productInfo, sizeInputs);
    setPendingButton(productInfo);
  };

  const initialise = (scope = document) => {
    if (scope.matches?.('product-info')) initialiseExplicitSize(scope);
    scope.querySelectorAll?.('product-info').forEach(initialiseExplicitSize);
  };

  document.addEventListener('product-info:loaded', (event) => initialiseExplicitSize(event.target));

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches?.('input[type="radio"]')) return;

    const label = input.id ? document.querySelector(`label[for="${input.id}"]`) : null;
    if (!label?.classList.contains('bordi-size-option')) return;

    const productInfo = input.closest('product-info');
    if (!productInfo) return;

    productInfo.dataset.bordiSizeSelected = 'true';
    const hint = productInfo.querySelector('[data-bordi-size-selection-hint]');
    hint?.remove();
    input.closest('fieldset')?.removeAttribute('aria-describedby');
  }, true);

  document.addEventListener('submit', (event) => {
    const productInfo = event.target.closest?.('product-info');
    if (!productInfo || productInfo.dataset.bordiSizeSelected !== 'false') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const hint = productInfo.querySelector('[data-bordi-size-selection-hint]');
    if (hint) {
      hint.textContent = 'Selecciona una talla antes de continuar';
      hint.classList.add('is-emphasised');
    }
    getAvailableSizeInputs(productInfo)[0]?.focus({ preventScroll: true });
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
      const productInfo = Array.from(document.querySelectorAll('product-info'))
        .find((item) => item.dataset.section === String(data?.sectionId));
      if (productInfo?.dataset.bordiSizeSelected === 'false') setPendingButton(productInfo);
    });
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }
})();
